import termsAndConditionsData from "../../js/auditionTermsAndConditionsData";
import { Newlogo } from "../../components";
const AuditionTermsAndConditions = () => {
  return (
    <div
      className={`bg-primary h-screen scroll-container xs:py-5 sm:pt-8 sm:pb-8 lg:pt-10 lg:pb-24`}
    >
      <div className="xs:pb-5 sm:pb-8 lg:pb-10 max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center">
          <Newlogo />
        </div>
      </div>
      <div className="max-w-5xl xl:px-10 lg:px-16 sm:px-14 xs:px-8 m-auto">
        <div className="flex justify-center items-center flex-col relative lg:py-8">
          <h1 className="uppercase text-secondary font-unboundedBold lg:text-3xl leading-4 sm:leading-5 lg:leading-tight">
            Acting Auditions 2026 Terms & Conditions
          </h1>
        </div>
        <div>
          {termsAndConditionsData?.map((item, index) => (
            <div key={index} className="xs:pt-2 sm:pt-4 lg:pt-8">
              <h1 className="text-goldMetallic font-onestRegular lg:text-xl leading-4 sm:leading-5 lg:leading-tight pb-1 whitespace-pre-line">
                {item?.title}
              </h1>
              <p className="text-[#707070] font-onestRegular lg:text-xl leading-4 sm:leading-5 lg:leading-tight whitespace-pre-line">
                {item?.description}
              </p>
              {/* <p className="">
                                    {item?.option?.map((option, index) => (
                                        <p key={index} className={`text-[#707070] font-onestRegular lg:text-xl leading-4 sm:leading-5 lg:leading-tight sm:py-3.5 py-2`}>
                                            {option?.text}
                                            {index !== option.length - 1 && <br />}
                                        </p>
                                    ))}
                                </p> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default AuditionTermsAndConditions;
